import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { defaultStaticRanges } from './defaultDates';
import { format } from 'date-fns';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import './style.css';

const DateRangeSelector = ({ ranges, onChange, onSubmit, ...rest }) => {
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  function formatDateDisplay(date, defaultText) {
    if (!date) return defaultText;
    return format(date, 'MMMM dd, yyyy'); // Corrected format: "MM" for month
  }

  const handleSelect = (ranges) => {
    setSelectedDateRange(ranges.selection);
  };

  const onClickDone = () => {
    onSubmit(selectedDateRange);
    rest.toggleModal();
  };

  const onClickClear = () => {
    setSelectedDateRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    });
    rest.toggleModal();
  };

  return (
    <React.Fragment>
      <div className="shadow d-inline-block">
        <DateRangePicker
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          ranges={[selectedDateRange]}
          staticRanges={ranges} // Added staticRanges prop
          inputRanges={[]} // Optionally, add custom input ranges here if needed
          direction="horizontal"
        />
        <div className="text-right position-relative rdr-buttons-position mt-2 mr-0 mb-2 ">
          <p className="my-auto d-inline mr-5">
            Range : {formatDateDisplay(selectedDateRange.startDate, 'N/A')}
            {' - '}
            {formatDateDisplay(selectedDateRange.endDate, 'N/A')}
          </p>
          <button
            className="btn btn-transparent text-black rounded px-2 border  mr-2"
            onClick={onClickClear}
          >
            Cancel
          </button>
          <Button
            className="bg-white !text-[#2d9f75] rounded px-2 mr-1"
            onClick={onClickDone}
          >
            Apply
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

DateRangeSelector.defaultProps = {
  ranges: defaultStaticRanges, // Use defaultStaticRanges as the default prop
};

DateRangeSelector.propTypes = {
  onSubmit: PropTypes.func,
  ranges: PropTypes.array, // Added this to indicate ranges as a prop
};

export default DateRangeSelector;
